import { intlService } from '~/i18n/IntlService';
import { SearchFilter } from '~/types/DashboardV2';

export const createBooleanTextSearchFilter = (): SearchFilter => {
  return {
    id: 'bool_text_search',
    label: intlService.getIntl().formatMessage({
      id: 'searchFiltersUtils.booleanTextSearchLabel',
      defaultMessage: 'Boolean Text Search',
      description: 'Label for boolean text search filter',
    }),
    type: 'bool_text_search',
    operators: [],
    section: 'More Filters',
    is_chartable: false,
    is_requestable_column: false,
    settings: {},
  };
};
